import { deleteKpi, getKpis, updateKpi } from '@/api/legacy/kpis';
import { naturalSort } from '@/helpers/util';
import StoreCache from '@/store/cache';
import { DELETE_KPI, FETCH_KPIS, UPDATE_KPI } from '@/store/types/actions';
import { KPIS_UPDATED, KPI_DELETED, KPI_UPDATED } from '@/store/types/mutations';

const cache = new StoreCache({ lifespan: 10000 });

// actions
const actions = {
  [FETCH_KPIS]({ commit, state }) {
    if (cache.isReady()) {
      return Promise.resolve(state.kpis);
    } if (cache.isPending()) {
      return cache.getPendingPromise();
    }

    return cache.setPendingPromise(getKpis().then((kpis) => {
      commit(KPIS_UPDATED, { kpis });
    }));
  },
  [UPDATE_KPI]({ commit }, kpi) {
    return updateKpi(kpi).then((res) => {
      // The result is just the id, so pass the kpi right through
      const updatedKpi = {
        $id: res.$id,
        ...kpi,
      };
      commit(KPI_UPDATED, { kpi: updatedKpi });
      return Promise.resolve({ ...updatedKpi });
    });
  },
  [DELETE_KPI]({ commit }, kpi) {
    if (!kpi || typeof kpi !== 'object') {
      return Promise.reject(new Error('A KPI object must be passed to be deleted'));
    }

    return deleteKpi(kpi.$id).then(() => {
      commit(KPI_DELETED, kpi.$id);
    });
  },
};

// mutations
const mutations = {
  [KPIS_UPDATED](state, { kpis }) {
    state.kpis = naturalSort(kpis, 'name');
  },
  [KPI_UPDATED](state, { kpi }) {
    let found = false;
    // Replace the single KPI with the updated version
    state.kpis = state.kpis.map((k) => {
      if (k.$id === kpi.$id) {
        found = true;
        return kpi;
      }
      return k;
    });

    if (!found) {
      state.kpis.push(kpi);
    }

    // Resort the kpis
    state.kpis = naturalSort(state.kpis, 'name');
  },
  [KPI_DELETED](state, kpiId) {
    state.kpis = state.kpis.filter((k) => k.$id !== kpiId);
  },
};

// getters
const getters = {
  kpis: (state) => state.kpis,
};

// initial state
const state = {
  kpis: [],
};

export default {
  state,
  getters,
  actions,
  mutations,
};
